import { render } from "./AddEditPriority.vue?vue&type=template&id=61688a8b"
import script from "./AddEditPriority.vue?vue&type=script&lang=js"
export * from "./AddEditPriority.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__